var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 44,
    viewBox: "0 0 26 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 13.7493C0 20.9607 11.6409 42.1739 12.1362 43.0734C12.316 43.3992 12.6462 43.5987 13 43.5987C13.3567 43.5987 13.6854 43.3992 13.8638 43.0734C14.3591 42.1739 26 20.9607 26 13.7493C26 6.16848 20.1685 0 12.9985 0C5.83297 0.00155888 0 6.16848 0 13.7493Z",
    fill: "#0074E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6289 14.0695C20.6289 18.517 17.2075 22.1352 13.0019 22.1352C8.79636 22.1352 5.375 18.517 5.375 14.0695C5.375 9.62206 8.79783 6.00391 13.0019 6.00391C17.209 6.00391 20.6289 9.62206 20.6289 14.0695Z",
    fill: "#FF724F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.8640148923cd33226043386293a39896.svg";
export { ForwardRef as ReactComponent };